import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {

  private permissionsSubject =
    new BehaviorSubject<any[]>([]);

  permissions$ =
    this.permissionsSubject.asObservable();

  constructor() {

    this.loadPermissionsFromStorage();

  }

  // =========================================
  // SET PERMISSIONS
  // =========================================

  setPermissions(permissions: any[]): void {

    localStorage.setItem(
      'permissions',
      JSON.stringify(permissions)
    );

    this.permissionsSubject.next(permissions);

  }

  // =========================================
  // LOAD FROM STORAGE
  // =========================================

  loadPermissionsFromStorage(): void {

    const permissions = JSON.parse(
      localStorage.getItem('permissions') || '[]'
    );

    this.permissionsSubject.next(permissions);

  }

  // =========================================
  // GET ALL
  // =========================================

  getPermissions(): any[] {

    return this.permissionsSubject.value;

  }

  // =========================================
  // HAS ACCESS
  // =========================================

  hasAccess(route: string): boolean {

    return this.permissionsSubject
      .value
      .some((x: any) => x.sbModUrl === route);

  }

  // =========================================
  // HAS ANY ACCESS
  // =========================================

  hasAnyAccess(routes: string[]): boolean {

    return routes.some((route) =>
      this.hasAccess(route)
    );

  }

  // =========================================
  // CLEAR
  // =========================================

  clearPermissions(): void {

    localStorage.removeItem('permissions');

    this.permissionsSubject.next([]);

  }

}